export default __webpack_public_path__ + "static/media/landingPage_4.b87e9d3f.jpg";